<template>
  <div class="all-content-container" style="margin: 2px">
    <div class="top-content-container">
      <div class="head_container">
        <div class="icon_text_container">
          <!-- <img class="icon" src="../assets/heals-log-theme.png" alt /> -->
          <div>BW Consultants</div>
        </div>
        <div v-if="!isMobile" class="top-tab-contianer">

          <div class="lang-text-container">
            <div class="lang-text" @click="exchangeEn">EN</div>
            <div class="lang-text" @click="exchangeCh">繁</div>
          </div>
        </div>
        <div v-else class="more-extend-contianer" @click="clickMobileMoreMenu">
          <img src="../assets/more.png" alt="" />
        </div>

        <div class="bottom-line"></div>
      </div>

      <div class="top-menu-container">
        <div class="back-title-contianer">
          <div class="back">
            <img class="back-icon" src="../assets/back.png" alt />
          </div>
          <div :class="isMobile ? 'title-mobile' : 'title'">
            <span>{{ lang.title }}</span>
          </div>
        </div>

        <div class="icon-center-container">
          <div class="icon-contianer">
            <div
              class="icon-one-item"
              v-for="(item, i) in lang.filterItmes"
              v-bind:key="i"
              @click="clickFilter(item)"
            >
              <img :src="item.icon" alt="" />
              <span>{{ item.title }}</span>
            </div>
          </div>
          <div
            v-show="showFilterOptions.length > 0"
            :class="
              isMobile
                ? 'filter-options-container-mobile'
                : 'filter-options-container'
            "
          >
            <div>
              <div
                v-for="(item, i) in showFilterOptions"
                v-bind:key="i"
                @click="clickFilterOptions(item)"
              >
                <div
                  :class="
                    isMobile ? 'filter-one-item-mobile' : 'filter-one-item'
                  "
                >
                  <span>{{ item.title }}</span>
                  <img
                    class="selected-icon"
                    :src="
                      item.isSelected
                        ? require('../assets/selected.png')
                        : require('../assets/un_selected.png')
                    "
                    alt=""
                  />
                </div>
                <div v-if="item.isSelected">
                  <div
                    v-for="(optionItem, i) in item.options"
                    v-bind:key="i"
                    @click.stop="clickDistrictOptions(optionItem)"
                  >
                    <div
                      :class="
                        isMobile
                          ? 'filter-district-item-mobile'
                          : 'filter-district-item'
                      "
                    >
                      <span>{{ optionItem.title }}</span>
                      <img
                        class="selected-icon"
                        :src="
                          optionItem.isSelected
                            ? require('../assets/selected.png')
                            : require('../assets/un_selected.png')
                        "
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="center-scroll-container">
      <!--  -->
      <div class="doctor-list-container">
        <div class="empty-contianer" v-if="dataIsEmpty">
          <div >{{lang.emptyTips}}</div>
        </div>
        <div v-else
          class="one_item"
          v-for="(item, i) in doctorList"
          v-bind:key="i"
        >
          <div class="one-line-contianer">
            <img src="../assets/hositoal.png" class="item-icon" />
            <span class="doctor-name center-text">{{ item.title }}</span>
            <img src="../assets/tag.png" class="item-icon" />
          </div>
          <div class="one-line-contianer">
            <span class="item-icon" />
            <span class="medical-center center-text">{{ item.subTitle }}</span>
            <span class="item-icon" />
          </div>
          <div class="one-line-contianer" @click.stop="clickAddress(item)">
            <img src="../assets/location.png" class="item-icon" />
            <span class="address center-text">{{ item.address }}</span>
            <span class="item-icon" />
          </div>
          <div class="one-line-contianer" @click.stop="clickPhone(item.phone)">
            <img src="../assets/phone.png" class="item-icon phone-icon" />
            <span class="phone center-text">{{ item.phone }}</span>
            <span class="item-icon" />
          </div>
          <div class="line"></div>
          <div class="gp-container">
            <div class="color-line"></div>
            <div class="type">{{ item.type }}</div>
          </div>
        </div>
      </div>
      <!--  -->
      <div class="load-more-container">
        <div
          v-if="totalCount > doctorList.length"
          class="center-more-container"
          @click="clickLoadMore"
        >
          <div class="load-more">{{ lang.loadMore }}</div>
        </div>
      </div>
    </div>

    <!--  -->
    <div
      :class="
        isMobile ? 'bottom-green-contianer-mobile' : 'bottom-green-contianer'
      "
    >
 
    </div>

    <div v-show="isShowMoreMune" class="mobile-more-menu-container">
      <div class="tab-one-item" @click="exchangeEn"><span>EN</span></div>
      <div class="tab-one-item" @click="exchangeCh"><span>繁</span></div>
    </div>
  </div>
</template>

<script>
import { env } from "process";
import { enFilterItems, chFilterItems } from "../../static/data.js";
export default {
  name: "heals-home",
  data() {
    return {
      langId: "en",
      lang: {},
      en: {
        title: "Doctor lists",
        loadMore: "LOAD MORE",
        touchTitle: "Get In Touch",
        healsPhone: "+852 2566 2661",
        healsAddress:
          "Unit A,7/F, Lippo Leighton Tower, 103 Leighton Rd, Causeway Bay, Hong Kong",
        healsEmail: "info@heals.asia",
        termsOfService: "Terms of Service",
        privocyPolicy: "Privacy Policy",
        healsReserved: "Copyright @c 2022 Heals All rights reserved",
        filterItmes: enFilterItems,
        emptyTips:'0 record is found'
      },
      ch: {
        title: "醫生列表",
        loadMore: "加載更多",
        touchTitle: "Get In Touch",
        healsPhone: "+852 2566 2661",
        healsAddress:
          "Unit A,7/F, Lippo Leighton Tower, 103 Leighton Rd, Causeway Bay, Hong Kong",
        healsEmail: "info@heals.asia",
        termsOfService: "Terms of Service",
        privocyPolicy: "Privacy Policy",
        healsReserved: "Copyright @c 2022 Heals All rights reserved",
        filterItmes: chFilterItems,
        emptyTips:'找到 0 條記錄'
      },
      doctorList: [],
      enDoctorList: [],
      chDoctorList: [],
      skip: 0,
      take: 10,
      isMobile: false,
      totalCount: 0,
      isShowMoreMune: false,
      showFilterOptions: [],
      showFilterTypeId: 0,
      dataIsEmpty:false
    };
  },

  mounted() {
    this.lang = this.en;
    this.getAuthToken();
    let that = this;
    that.updateUIFrame();
    window.onresize = function () {
      that.updateUIFrame();
    };
  },
  methods: {
    updateUIFrame() {
      let width = window.innerWidth;
      this.isMobile = width < 1000;
    },
    exchangeCh() {
      this.langId = "ch";
      this.lang = this.ch;
      this.doctorList = this.chDoctorList;
      this.isShowMoreMune = false;
    },
    exchangeEn() {
      this.langId = "en";
      this.lang = this.en;
      this.doctorList = this.enDoctorList;
      this.isShowMoreMune = false;
    },
    clickMobileMoreMenu() {
      this.isShowMoreMune = !this.isShowMoreMune;
    },
    clickMoreMune() {
      this.isShowMoreMune = false;
    },
    clickFilter(item) {
      if (this.showFilterOptions && this.showFilterOptions.length > 0) {
        this.showFilterOptions = [];
      } else {
        this.showFilterTypeId = item.id;
        this.showFilterOptions = item.options;
      }
    },
    clickFilterOptions(item) {
      let enOptions = this.en.filterItmes.find(
        (element) => element.id === this.showFilterTypeId
      ).options;
      let enItem = enOptions.find((element) => element.id === item.id);
      let isCanceled = enItem.isSelected;
      enOptions.forEach((element) => {
        element.isSelected = false;
      });

      enItem.isSelected = isCanceled ? false : true;

      let chOptions = this.ch.filterItmes.find(
        (element) => element.id === this.showFilterTypeId
      ).options;
      chOptions.forEach((element) => {
        element.isSelected = false;
      });
      let chItem = chOptions.find((element) => element.id === item.id);
      chItem.isSelected = isCanceled ? false : true;
      if (chItem.options.length === 0 || chItem.isSelected === false) {
        this.showFilterOptions = [];
        this.skip = 0;
        this.getDataList();
      }
    },
    clickDistrictOptions(item) {
      this.showFilterOptions = [];
      let enOptions = this.en.filterItmes.find(
        (element) => element.id === this.showFilterTypeId
      ).options;
      enOptions = enOptions.find(
        (element) => element.isSelected === true
      ).options;
      let enItem = enOptions.find((element) => element.id === item.id);
      let isCanceled = enItem.isSelected;

      enOptions.forEach((element) => {
        element.isSelected = false;
      });

      enItem.isSelected = isCanceled ? false : true;

      let chOptions = this.ch.filterItmes.find(
        (element) => element.id === this.showFilterTypeId
      ).options;
      chOptions = chOptions.find(
        (element) => element.isSelected === true
      ).options;
      chOptions.forEach((element) => {
        element.isSelected = false;
      });
      let chItem = chOptions.find((element) => element.id === item.id);
      chItem.isSelected = isCanceled ? false : true;
      this.skip = 0;
      this.getDataList();
    },

    clickPhone(phone){
      let str = phone.replace('+','')
      str = str.replace('-',"")
      window.location.href = 'tel://' + str
    },
    clickAddress(item){
      // window.location.href ="http://api.map.baidu.com/marker?location=24.5019,118.1329&title=泉州xx科技有限公司&content=泉州xx科技有限公司&output=html"
    },
    getAuthToken() {
      this.$get("/api/graphql", {}, this, {}).then((data) => {
        let token = data.data.generateAccessToken.access_token;
        this.$setAuthToken(token);
        this.getDataList();
        this.getSpecialItems();
      });
    },

    getSpecialItems(){
      this.$get("/api/getSpecialty", {}, this, {}).then((data) => {
        let enFilter = this.en.filterItmes.find(element=>element.id === 2).options.find(element=>element.id === 2)
        enFilter.options = []
        let chFilter = this.ch.filterItmes.find(element=>element.id === 2).options.find(element=>element.id === 2)
        chFilter.options = []
        data.data.listLookups.items.forEach(element=>{
          
          const values = element.nameMultilingual.values
          let enValue = values.find(e=>e.lang==='en-US').value 
          let chValue = values.find(e=>e.lang==='zh-Hant').value 
          enFilter.options.push({
            id:element.id,
            title:enValue,
            value:element.id,
            isSelected:false,
          })
          chFilter.options.push({
            id:element.id,
            title:chValue && chValue.length > 0 ? chValue : enValue,
            value:element.id,
            isSelected:false,
          })
        })
      });
    },

    getDataList() {
      let that = this;
      var params = {
        skip: this.skip,
        take: this.take,
      };
      try {
        let areaOptions = this.lang.filterItmes.find(
          (element) => element.id === 1
        ).options;
        let areaSelected = areaOptions.find((element) => element.isSelected);
        params.area = areaSelected.value;

        try {
          let area2Selected = areaSelected.options.find(
            (element) => element.isSelected === true
          );
          if (area2Selected.value.length > 0) {
            params.area2 = area2Selected.value;
          }
        } catch (error) {}
      } catch (error) {}

      let specialtyId = ''
      try {
        let areaOptions = this.lang.filterItmes.find(
          (element) => element.id === 2
        ).options;
        let doctorTypeSelected = areaOptions.find(
          (element) => element.isSelected
        );
        params.typeId = doctorTypeSelected.value;
        if(doctorTypeSelected.id !== 1){
           try {
             let specialSelected = doctorTypeSelected.options.find(element=>element.isSelected)
             params.specialty_id = specialSelected.value
             specialtyId = specialSelected.id
           } catch (error) {}   
        }
      } catch (error) {}

      if (this.skip === 0) {
        this.doctorList = [];
        this.enDoctorList = [];
        this.chDoctorList = [];
        this.totalCount = 0;
      }
      this.dataIsEmpty = false

      this.$get("/api/listProviders", params, this, {}).then((res) => {
        let dataList = res.data.listProviders.items;
        this.totalCount = res.data.listProviders.totalCount;
        let gpTypeIds = [
          "0cd2c701-ee37-45c9-9a6e-ffc565060d20",
          "1d2a75c2-008e-42d9-bae0-dcd695e57819",
        ];
        let phTypeIds = [
          "e8c8614a-c2ba-40a6-a4d2-ab93539778f4"
        ]
        dataList.forEach((element) => {
          const contactObj = element.location.contacts.find(
            // 这里不是很准确，生产环境是phone.office,开发环境是phone.mobile
            (a) => a.key.indexOf("phone") !== -1
          );
          const docotorObj = JSON.parse(element.practitioner.valueAsString);
          const localtionObj = JSON.parse(element.location.valueAsString)
          let enType = "SP";
          let chType = "專科"
          if (gpTypeIds.indexOf(docotorObj.typeId) !== -1) {
            enType = "GP";
            chType = "普通科"
          }else if(phTypeIds.indexOf(docotorObj.typeId) !== -1){
            enType = "PHYSIO";
            chType = "物理治療"
          }
          if(specialtyId.length > 0){
            const enSpecialItem = this.en.filterItmes.find(element=>element.id === 2).options.find(element=>element.isSelected).options.find(element=>element.isSelected)
            enType = enType + "   " + enSpecialItem.title
            const chSpecialItem = this.ch.filterItmes.find(element=>element.id === 2).options.find(element=>element.isSelected).options.find(element=>element.isSelected)
            chType = chType + "   " + chSpecialItem.title
          }

         const addresses = element.location.addresses[0].fields;
          let enAddress = addresses.find((obj) => obj.key === "streetAddress");
          let title = "DR." + docotorObj.lastName + " " + docotorObj.firstName;
          title = title.toUpperCase();
          let enObj = {
            id: element.id,
            code: element.code,
            title,
            subTitle: element.location.name,
            address: enAddress.value,
            phone: contactObj.value,
            type: enType,
          };
          let chAddress = addresses.find(
            (obj) => obj.key === "streetAddressTraditionalChinese"
          );
          let chObj = {
            id: element.id,
            code: element.code,
            title: docotorObj.nameTraditionalChinese,
            subTitle: localtionObj.nameTraditionalChinese,
            address: chAddress.value,
            phone: contactObj.value,
            type: chType,
          };
          if(enObj.subTitle.indexOf('Heals') === -1){
            //去掉heals虚拟诊所
            this.enDoctorList.push(enObj);
            this.chDoctorList.push(chObj);
          }
        });
        this.doctorList =
          that.langId === "en" ? this.enDoctorList : this.chDoctorList;
          this.dataIsEmpty = this.doctorList.length === 0
      });
    },

    // 点击加载更多
    clickLoadMore() {
      this.skip = this.skip + this.take;

      this.getDataList();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../style/heals-home.css";
</style>



// WEBPACK FOOTER //
// src/components/heals-home.vue